import Request, { ApiMode } from '../../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';

export const CARD_OR_BACS = new Set(['card', 'bacs']);

const requestOptions = (isLocal) => ({
	local: isLocal,
	req: { apiMode: ApiMode.LtaError }
});

/**
 * @param {string} endpoint
 * @param {{ paymentMethod: string, checkoutData: object, isLocal?: boolean }} options
 * @returns {Promise<{ ok: true, redirectUrl: string } | { ok: false, errorMessage: string }>}
 */
export async function createStripeCheckoutSession(
	endpoint,
	{ paymentMethod, checkoutData, isLocal = false } = {}
) {
	if (!endpoint) {
		return { ok: false, errorMessage: 'Payment endpoint is not configured.' };
	}

	startLoadingAnimation();

	try {
		const response = await Request.post(
			endpoint,
			{
				paymentMethod,
				totalCost: checkoutData?.totalCost,
				lineItems: checkoutData?.lineItems,
				currency: checkoutData?.currency || 'gbp',
				// Pass through so backend can (re)compute/validate server-side.
				// Client data can be manipulated, so backend should not blindly trust it.
				isMultiSite: checkoutData?.isMultiSite
			},
			requestOptions(isLocal)
		);

		stopLoadingAnimation();

		const redirectUrl = response?.redirectUrl || response?.redirectURL;
		const succeeded = response?.Success || response?.success;

		if (response?.errorMessage) {
			return { ok: false, errorMessage: response.errorMessage };
		}

		if (succeeded && redirectUrl) {
			return { ok: true, redirectUrl };
		}

		return { ok: false, errorMessage: 'Unable to start payment. Please try again.' };
	} catch (error) {
		stopLoadingAnimation();
		// eslint-disable-next-line no-console
		console.error('SubmitRegistration – payment error:', error?.message || error);
		return {
			ok: false,
			errorMessage: error?.message || 'Unable to start payment. Please try again.'
		};
	}
}

export function isFreeDemoRequest() {
	const free = new URLSearchParams(window.location.search).get('free');
	return free === '1' || free === 'true';
}
